<MenuItem iconF7="rectangle_stack_badge_plus" iconOnly {iconSize} on:click={handleClick} />

<style>
  *, *::before, *::after {
    box-sizing: border-box;
  }</style>

<script lang="ts">import { MenuItem } from 'framework7-svelte';
import './CardsEditorComponentInterfaces';
import './CardsEditorLayerTree.svelte';
import { CardsPageContextKey } from './context';
import { getContext } from 'svelte';
export let iconSize = 20;
const pageContext = getContext(CardsPageContextKey);
const selectedComponentStore = pageContext.editorModeManager.getSelectedComponentStore();
$: selectedComponent = $selectedComponentStore;
function handleClick() {
    selectedComponent === null || selectedComponent === void 0 ? void 0 : selectedComponent.addChild();
}
</script>